// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__soWJA","footer":"ModalCreateQualiphyProcedure_footer__2-Hog","additionData":"ModalCreateQualiphyProcedure_additionData__1zYJE"};